import PropTypes from 'prop-types';
import React from 'react';
import debounce from 'lodash/debounce';
import { withRouter } from 'next/router';
import styled from 'styled-components';
import { AmpForm } from '../../../amp/form';
import { track } from '../../../analytics/analytics';


const Input = styled.input`
  &.form-control:focus {
    box-shadow: 0 0 0 2px var(--blue-brdr);
    border-color: var(--blue-brdr);
  }
`;

const trackFn = (value) => {
  track({ category: 'SearchInput', action: 'Change', label: value });
};

const trackFnDebounced = debounce(trackFn, 300);

const SearchInputFormView = ({
  name,
  value,
  placeholder = '',
  children,
  router,
  handleSubmit,
  handleChange,
  action,
  label,
  id,
}) => (
  <AmpForm>
    <form
      target="_top"
      method="GET"
      action={action || router.asPath.split('?')[0]}
      className="js-focus-state"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      {Object.keys(router.query).filter((key) => key !== name).map((key) => (
        <input key={key} type="hidden" name={key} value={router.query[key]} />
      ))}
      {label}
      <div className="input-group">
        <Input
          id={id}
          type="text"
          name={name}
          className="form-control amp-track"
          placeholder={placeholder}
          aria-label={placeholder}
          value={value}
          data-vars-track-category="SearchInput"
          data-vars-track-action="Change"
          data-vars-track-label=""
          onChange={(e) => {
            const { value: newValue } = e.target;

            handleChange(newValue);
            trackFnDebounced(newValue);
          }}
        />
        {children}
      </div>
    </form>
  </AmpForm>
);

export const SearchInputForm = withRouter(SearchInputFormView);

SearchInputForm.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  action: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

SearchInputFormView.propTypes = {
  ...SearchInputForm.propTypes,
  router: PropTypes.shape({
    asPath: PropTypes.string.isRequired,
    query: PropTypes.shape({}),
  }),
};
